import React from 'react';
import { FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LayerControlRadioProps = {
  value: string;
  checked: boolean;
  onChange: (newChecked: boolean) => void;
  i18nKey: string;
};
export const LayerControlRadio = ({ value, checked, onChange, i18nKey }: LayerControlRadioProps) => {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      sx={{ fontSize: '0.8rem' }}
      label={t(`${i18nKey}.${value}`)}
      control={<Radio checked={checked} onChange={(event, newChecked) => onChange(newChecked)} size="small" />}
    />
  );
};
